import styled from 'styled-components';
import * as style from 'styles';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 390px;
  float: none;
  margin-left: auto;
  margin-right: auto;
`;

export const ContentWrapper = styled.div`
  overflow: auto;
  padding-top: 30px;
  text-align: center;

  img {
    width: 100%;
    height: auto;
  }

  div {
    margin: ${style.spacing.three} 0;
  }
`;
